// this file is automatically generated by git.revision.js script
export const versions = { revision: 'e55159041a' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'e55159041a';
